const CONFIG = {
  1: { label: 'Fácil',       className: 'bg-green-100 text-green-700',    dotFill: 'bg-green-500' },
  2: { label: 'Medio',       className: 'bg-yellow-100 text-yellow-700',  dotFill: 'bg-yellow-400' },
  3: { label: 'Difícil',     className: 'bg-orange-100 text-orange-600',  dotFill: 'bg-orange-500' },
  4: { label: 'Muy difícil', className: 'bg-orange-200 text-orange-800',  dotFill: 'bg-orange-700' },
};

const TOTAL_DOTS = 4;

export default function DificultadBadge({ value }) {
  const cfg = CONFIG[value];
  if (!cfg) return <span className="text-slate-400">—</span>;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-medium ${cfg.className}`}>
      {cfg.label}
      <span className="inline-flex items-center gap-0.5">
        {Array.from({ length: TOTAL_DOTS }, (_, i) => (
          <span
            key={i}
            className={`inline-block w-1.5 h-1.5 rounded-full ${i < value ? cfg.dotFill : 'bg-current opacity-20'}`}
          />
        ))}
      </span>
    </span>
  );
}
